module.exports = __webpack_public_path__ + "static/media/1POLICY21.cfc2ff69.jpg";